// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getBuilderIOClassName(attributes: any) {
  const styles: string[] =
    (attributes?.className &&
      attributes.className
        .split(' ')
        .filter(
          (className: string) =>
            className.startsWith('builder-') || className.startsWith('css-')
        )) ||
    [];
  return styles.join(' ');
}
